import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import PropTypes from "prop-types";

import { useStyles } from "./Toast.styles";

function Toast({ message, open, severity, handleClose, icon, duration }) {
  const classes = useStyles();

  return (
    <Snackbar
      autoHideDuration={duration}
      open={open}
      onClose={handleClose}
      className={classes.toast}
    >
      <Alert icon={icon} severity={severity} elevation={6} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
}

Toast.defaultProps = {
  duration: 5000,
};

Toast.propTypes = {
  message: PropTypes.string,
  open: PropTypes.bool,
  severity: PropTypes.string,
  handleClose: PropTypes.func,
  icon: PropTypes.node,
  duration: PropTypes.number,
};

export { Toast };
